import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MeasurementUnitFormComponent } from "./measurement-unit-form/measurement-unit-form.component";
import { MeasurementUnitListComponent } from "./measurement-unit-list/measurement-unit-list.component";
import { SalePriceTypeFormComponent } from "./sale-price-type-form/sale-price-type-form.component";
import { SalePriceTypeListComponent } from "./sale-price-type-list/sale-price-type-list.component";
import { ItemFormComponent } from "./item-form/item-form.component";
import { ItemListComponent } from "./item-list/item-list.component";
import { ItemCategoryFormComponent } from "./item-category-form/item-category-form.component";
import { ItemCategoryListComponent } from "./item-category-list/item-category-list.component";
import { DescriptionFormComponent } from "./description-form/description-form.component";
import { DescriptionListComponent } from "./description-list/description-list.component";
import { AdditiveFormComponent } from "./additive-form/additive-form.component";
import { AdditiveListComponent } from "./additive-list/additive-list.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { ItemPriceChangeFormComponent } from "./item-price-change/item-price-change-form/item-price-change-form.component";
import { ItemPriceChangeListComponent } from "./item-price-change/item-price-change-list/item-price-change-list.component";
import { ItemCategorySelectFormComponent } from "./item-category-form/item-category-select-form/item-category-select-form.component";
import { SaleFormulaComponent } from "../inv/sale-formula/sale-formula.component";
import { SaleItemFormComponent } from "../inv/sale-formula/sale-item-form/sale-item-form.component";
import { SaleItemListComponent } from "../inv/sale-formula/sale-item-list/sale-item-list.component";


const components = [
  MeasurementUnitFormComponent,
  MeasurementUnitListComponent,
  SalePriceTypeFormComponent,
  SalePriceTypeListComponent,
  ItemFormComponent,
  ItemListComponent,
  ItemCategoryFormComponent,
  ItemCategorySelectFormComponent,
  ItemCategoryListComponent,
  DescriptionFormComponent,
  DescriptionListComponent,
  AdditiveFormComponent,
  AdditiveListComponent,
  ItemPriceChangeFormComponent,
  ItemPriceChangeListComponent,
  SaleFormulaComponent,
  SaleItemFormComponent,
  SaleItemListComponent
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class CatalogModule {}
